import { HttpService } from '@skylab-shared/core';
import { EventNotification, EventNotificationsServiceBase, EventNotificationType } from '../../event-notifications.service-base';
import { NotificatorBase } from '../notificator-base';

export class KsefConfigurationStatusNotificatorBase extends NotificatorBase<void, void> {
    protected readonly eventType: EventNotificationType = 'KsefConfigurationStatusUpdate';

    public constructor(
        eventNotifications: EventNotificationsServiceBase,
        http: HttpService
    ) {
        super(eventNotifications, http);
    }

    protected prepareDataAsync(_: EventNotification<unknown>[]): Promise<void> {
        return Promise.resolve(void 0);
    }

}
